'use client';

import { useState } from 'react';

const categories = [
  { id: 'cat_all', name: 'All', value: 'all' },
  { id: 'cat_weddings', name: 'Weddings', value: 'weddings' },
  { id: 'cat_portraits', name: 'Portraits', value: 'portraits' },
  { id: 'cat_events', name: 'Events', value: 'events' },
  { id: 'cat_fashion', name: 'Fashion', value: 'fashion' },
  { id: 'cat_commercial', name: 'Commercial', value: 'commercial' },
  { id: 'cat_video', name: 'Video', value: 'video' },
];

export default function CategoryFilter() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <section data-component-id="src/app/portfolio/components/CategoryFilter.tsx:19:4" data-component-path="src/app/portfolio/components/CategoryFilter.tsx" data-component-line="19" data-component-end-line="35" data-component-file="CategoryFilter.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22px-6%20md%3Apx-12%20max-w-container%20mx-auto%20mb-12%22%7D" className="px-6 md:px-12 max-w-container mx-auto mb-12">
      <div data-component-id="src/app/portfolio/components/CategoryFilter.tsx:20:6" data-component-path="src/app/portfolio/components/CategoryFilter.tsx" data-component-line="20" data-component-end-line="34" data-component-file="CategoryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
        {categories?.map((category) => (
          <button data-component-id="src/app/portfolio/components/CategoryFilter.tsx:22:10" data-component-path="src/app/portfolio/components/CategoryFilter.tsx" data-component-line="22" data-component-end-line="32" data-component-file="CategoryFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category?.id}
            onClick={() => setActiveCategory(category?.value)}
            className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
              activeCategory === category?.value
                ? 'bg-primary text-primary-foreground shadow-lg'
                : 'bg-white/5 text-muted-foreground hover:bg-white/10 hover:text-foreground'
            }`}
          >
            {category?.name}
          </button>
        ))}
      </div>
    </section>
  );
}